import { useCallback } from 'react'
import { disconnectToolkit } from '@/services/connectionsSession'

export function useConnectionRowMenuActions({ menuRowId, connections, refetch }) {
  return useCallback(
    (itemId) => {
      if (menuRowId == null) return
      if (itemId === 'connection-reauthenticate') {
        return
      }
      if (itemId === 'connection-disconnect') {
        const row = connections.find((r) => r.id === menuRowId)
        const toolkitSlug =
          row?.toolkitSlug ||
          (String(menuRowId).startsWith('toolkit-') ? String(menuRowId).slice('toolkit-'.length) : '')
        if (toolkitSlug) {
          disconnectToolkit({ toolkitSlug, accountId: menuRowId })
          void refetch()
        }
      }
    },
    [menuRowId, connections, refetch],
  )
}
